import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import SearchableSelect from '../SearchableSelect';

export default function SupportedCountrySelect({
  id = undefined,
  name = undefined,
  value = '',
  onChange = undefined,
  className = undefined,
  disabled = false,
  includeEmptyOption = true,
  emptyOptionLabel = 'Select country',
  hasError = false,
  clearable = true,
}) {
  const allowedOnboardingCountries = useSelector((state) => state.config?.allowedOnboardingCountries ?? []);

  const options = React.useMemo(() => {
    if (!Array.isArray(allowedOnboardingCountries)) return [];
    const mapped = allowedOnboardingCountries
      .map((c) => ({
        value: (c?.code ?? '').toUpperCase(),
        label: c?.name ?? c?.code ?? '',
        searchText: `${c?.name ?? ''} ${c?.code ?? ''}`.trim(),
      }))
      .filter((c) => c.value);
    const normalizedValue = (value ?? '').toUpperCase();
    if (normalizedValue && !mapped.some((o) => o.value === normalizedValue)) {
      mapped.unshift({ value: normalizedValue, label: normalizedValue, searchText: normalizedValue });
    }
    return mapped;
  }, [allowedOnboardingCountries, value]);

  const isDisabled = disabled || options.length === 0;
  const placeholder = options.length === 0 ? 'Loading countries…' : emptyOptionLabel;

  return (
    <SearchableSelect
      id={id}
      name={name || id || 'country'}
      value={(value ?? '').toUpperCase()}
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      searchPlaceholder='Search country...'
      menuPlacement='auto'
      menuMaxHeight={240}
      menuMinWidth='w-full'
      clearable={includeEmptyOption && clearable}
      hasError={hasError}
      disabled={isDisabled}
      triggerClassName={className}
      showCountryFlags
    />
  );
}

SupportedCountrySelect.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  includeEmptyOption: PropTypes.bool,
  emptyOptionLabel: PropTypes.string,
  hasError: PropTypes.bool,
  clearable: PropTypes.bool,
};
